import React from 'react';

import { Icon, IconType } from '../icon';
import classNames from './EABD2CircleIcon.module.scss';
import { StyleUtil } from 'ui/util';

export type CircleIconColorType = 'secondary' | 'tertiary' | 'quaternary';

export interface CircleIconProps
  extends Readonly<{
    type: IconType;
    color: CircleIconColorType;
    shouldUseOutlineStyle?: boolean;
    shouldAnimatedStyleChange?: boolean;
  }> {}

export const CircleIcon = React.memo<CircleIconProps>((props) => {
  const { type, color, shouldUseOutlineStyle = false, shouldAnimatedStyleChange = false } = props;

  const RootClassNames = React.useMemo(() => {
    const rootClassNames = StyleUtil.createInitialClassNameArray(classNames.root);

    rootClassNames.push(classNames[color]);

    if (shouldUseOutlineStyle) {
      rootClassNames.push(classNames.outline);
    }

    if (shouldAnimatedStyleChange) {
      rootClassNames.push(classNames.animated);
    }

    return StyleUtil.mergeClassNames(rootClassNames);
  }, [color, shouldUseOutlineStyle, shouldAnimatedStyleChange]);

  return (
    <div className={RootClassNames}>
      <div className={classNames.iconWrapper}>
        <Icon type={type} />
      </div>
    </div>
  );
});
